import { InvestmentAccreditation } from '../../../InvestorQualification';
import PaymentPage from '../PaymentPage';
import SignAgreement from '../SignAgreement';

export const qualificationPath = '/opportunity/:id/investment/investor-qualification';
export const paymentPath = '/opportunity/:id/investment/payment';

const routes = [
  {
    path: qualificationPath,
    name: 'Investor Qualification',
    component: InvestmentAccreditation,
    isComplete: true,
    exact: true,
  },
  {
    path: '/opportunity/:id/investment/agreement',
    name: 'Sign agreement',
    component: SignAgreement,
    isComplete: true,
    exact: true,
  },
  {
    path: paymentPath,
    name: 'Payment',
    component: PaymentPage,
    isComplete: true,
    exact: true,
  },
];

export const getOpportunityRoutes = (isAccredited, isAccreditedFirst, skipAccreditation) => (((isAccredited && isAccreditedFirst)
  || skipAccreditation) ? routes.filter(({ path }) => path !== qualificationPath) : routes);
